//
// scroll vers le formulaire
//
if(document.getElementById('form')) {
	let form			= document.getElementById('form');
	let href			= form.getAttribute('data-href');

	if(href && document.getElementById(href)) {
		let targetE		= document.getElementById(href);
		let targetEOT	= targetE.offsetTop;
		let y = targetE.getBoundingClientRect().y;

		let scrollOpt	= {
			top: (y - targetEOT),
			behavior: 'smooth'
		};

		window.scroll(scrollOpt);
	}
}

//
// validation puis envoi du formulaire affiché via la disposition unique "Formulaire"
//
let formSubmit			= document.querySelector('form.form button[type=submit]');

formSubmit && formSubmit.addEventListener('click', function(event) {
	event.preventDefault();

	let form			= document.querySelector('form.form');

	if(form.checkValidity()) {
		if(document.querySelector('body').classList.contains('local')) {
			form.submit();
		} else {
			if(document.querySelector('.response')) {
				grecaptcha.ready(() => {
					// public api key
					grecaptcha.execute('6LdtaTsqAAAAAAqATzjxWM-VBqFVSXNcb9KchQXY', {
						action: 'submit'
					}).then(token => {
						document.querySelector('.response').value = token;
						form.submit();
					});
				});
			}
		}
	} else {
		form.classList.add('was-validated');
	}
});